import mediaQueries from 'app/utils/mediaQueries';
import { isObject } from 'lodash';
import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import SizesList from './sizeSelectorList';
import { getGroupedKidsSize, isGroupedSizeSelector } from './sizeSelectorUtils';

const SizesListWrapper = ({ country, sizes, getDisplayText, ...restOfProps }) => {
  if (isGroupedSizeSelector(sizes)) {
    const groupedKidsSizes = getGroupedKidsSize(sizes, country);
    const displayText = getDisplayText();
    const isTitleText = mediaQueries.is_medium_to_large() && restOfProps.scrollableList;
    return Object.keys(groupedKidsSizes)
      .filter(key => groupedKidsSizes[key].length > 0)
      .map(key => (
        <Fragment key={key}>
          <span className={`size-selector__${key}-title`}>
            <FormattedMessage id={`products.pdp.kids.sizes.${key}${isTitleText ? '.title' : ''}`} />
            {isObject(displayText) && displayText[key] && (
              <span role="alert" title="selected size" className="size-selector__display-text">
                &nbsp;{displayText[key]}
              </span>
            )}
          </span>
          <SizesList {...restOfProps} sizes={groupedKidsSizes[key]} />
        </Fragment>
      ));
  }
  return <SizesList {...restOfProps} sizes={sizes} />;
};

export default SizesListWrapper;
